import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-gtag';

// eslint-disable-next-line no-unused-vars
const ForwardOutboundLink = React.forwardRef((props, ref) => (
  <OutboundLink {...props} />
));

export default ForwardOutboundLink;
